import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Cart, DeliveryMode, OrderEntry } from '@spartacus/cart/base/root';
import { CheckoutPaymentFacade } from '@spartacus/checkout/base/root';
import {
  Address, TranslationService
} from '@spartacus/core';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { UigCartGroupingService } from '../../uig-cart/uig-cart-grouping/uig-cart-grouping.service';
import { PlaceOrderForm } from '../uig-checkout.models';
import { UigCheckoutService } from '../uig-checkout.service';
import { UigDirectDeliveryComponent } from '../uig-direct-delivery/uig-direct-delivery.component';

@Component({
    selector: 'app-uig-review-submit',
    templateUrl: './uig-review-submit.component.html',
    styleUrls: ['./uig-review-submit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigReviewSubmitComponent {
  placeOrderForm: PlaceOrderForm;
  deliveryModes: DeliveryMode[];
  deliveryAddresses: Address[];
  directDeliveryAddress: Address;
  addressSelectionActivated: boolean = true;
  isDirectDeliveryAllowed: boolean = false;
  vendorEntryGroups$: Observable<any[]>;

  constructor(
    protected activeCartService: ActiveCartService,
    protected translation: TranslationService,
    protected checkoutPaymentService: CheckoutPaymentFacade,
    protected modalService: NgbModal,
    protected uigCheckoutService: UigCheckoutService,
    protected uigCartGroupingService: UigCartGroupingService,
    private cdRef: ChangeDetectorRef
  ) {
    this.placeOrderForm = uigCheckoutService.createPlaceOrderForm();

    combineLatest([this.cart$, uigCheckoutService.checkoutData()]).pipe(
      filter(([cart, checkoutData]) => cart != null && checkoutData != null),
      tap(([cart, checkoutData]) => {
        this.placeOrderForm.purchaseOrderNumber = cart.purchaseOrderNumber;
        this.placeOrderForm.deliveryTicket = cart.deliveryTicket;

        this.isDirectDeliveryAllowed = checkoutData.directDeliveryAllowed;
        this.deliveryModes = checkoutData.deliveryModes;
        if (cart.entries?.filter(entry => entry.product.marketplace).length) {
          this.deliveryModes = this.deliveryModes.filter(mode => mode.code !== "pickup");
        }
        if (cart.entries?.filter(entry => entry.product.dropShipmentExcluded).length) {
          this.isDirectDeliveryAllowed = false;
        }

        this.deliveryAddresses = checkoutData.deliveryAddresses;
        this.selectDeliveryMode(
          this.deliveryModes.find((mode) => mode.selected).code
        );
        this.placeOrderForm.selectedDeliveryAddressId =
          this.deliveryAddresses.find((address) => address.defaultAddress).id;
        this.refreshData();
      })
    ).subscribe();

    this.vendorEntryGroups$ = this.cart$.pipe(map((cart) => {
      return this.uigCartGroupingService.groupByVendor(cart.entries, cart.groupSums);
    }))
  }

  get cart$(): Observable<Cart> {
    return this.activeCartService.getActive();
  }

  get entries$(): Observable<OrderEntry[]> {
    return this.activeCartService.getEntries();
  }

  selectDeliveryMode(deliveryModeCode: string): void {
    this.placeOrderForm.selectedDeliveryModeCode = deliveryModeCode;
    this.addressSelectionActivated = 'standard-net' === deliveryModeCode;
    this.uigCheckoutService.pickup.emit('pickup' === deliveryModeCode);
  }

  selectDeliveryAddressMode(deliveryAddressMode: boolean): void {
    this.placeOrderForm.isDirectDelivery = deliveryAddressMode;
    this.uigCheckoutService.deliveryAddressMode.emit(deliveryAddressMode);
  }

  onDirectDelivery(): void {
    this.modalService
      .open(UigDirectDeliveryComponent, { centered: true })
      .result.then(
        (result) => {
          this.placeOrderForm.isDirectDelivery = true;
          this.refreshData();
        },
        (reason) => { }
      );
  }

  onDeleteDirectDelivery(): void {
    this.placeOrderForm.directDeliveryAddress = null;
    this.refreshData();
  }

  refreshData(): void {
    this.directDeliveryAddress =
      this.placeOrderForm.directDeliveryAddress;
    this.cdRef.detectChanges();
  }
}
